import React from "react";
import { Link } from "react-router-dom";
import { useLazyQuery } from "@apollo/react-hooks";
import { GET_ALL_POST } from "../../query/GetPosts";
import { hasuraClient } from "../../apolloClient";
import PostTab from "./PostTab";
import { Tab, Nav } from "react-bootstrap";

const PostsMainPage = () => {
  const [
    searchPublishedPosts,
    {
      data: publishedPosts,
      refetch: publishRefetch,
      loading: publishedPostLoading,
      error: publishedPostError,
    },
  ] = useLazyQuery(GET_ALL_POST, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
    variables: {
      profile_id: localStorage.getItem("profile_id"),
    },
  });

  const [
    searchDraftPosts,
    {
      data: draftPosts,
      refetch: draftRefetch,
      loading: draftPostLoading,
      error: draftPostError,
    },
  ] = useLazyQuery(GET_ALL_POST, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
    variables: {
      profile_id: localStorage.getItem("profile_id"),
    },
  });

  const [
    searchQuery,
    { data, refetch, loading: allPostLoading, error: allPostError },
  ] = useLazyQuery(GET_ALL_POST, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    client: hasuraClient,
    variables: {
      profile_id: localStorage.getItem("profile_id"),
    },
  });

  React.useEffect(() => {
    searchQuery({
      variables: {
        status: ["draft", "published", "scheduled"],
      },
    });
    searchPublishedPosts({
      variables: {
        status: ["scheduled"],
      },
    });
    searchDraftPosts({
      variables: {
        status: ["draft"],
      },
    });
  }, []);

  return (
    <section className="post-block">
      <div className="main-title">
        <h1>Post</h1>
        <div className="post-button">
          <Link to="/create-post" className="button">
            Create Post
          </Link>
        </div>
      </div>
      <div className="post-tab">
        <Tab.Container id="left-tabs-example" defaultActiveKey="All">
          <Nav variant="pills" className="flex-column">
            <Nav.Item>
              <Nav.Link eventKey="All">
                <span className="tab-name">All</span>
                <span className="count">
                  {data?.posts_total?.aggregate?.count}
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item
              onClick={() => {
                publishRefetch();
              }}
            >
              <Nav.Link eventKey="Published">
                <span className="tab-name">Upcoming</span>
                <span className="count">
                  {publishedPosts?.posts_total?.aggregate?.count}
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item onClick={() => draftRefetch()}>
              <Nav.Link eventKey="Drafts">
                <span className="tab-name">Drafts</span>
                <span className="count">
                  {draftPosts?.posts_total?.aggregate?.count}
                </span>
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="All">
              <PostTab
                data={data}
                refetch={refetch}
                isAll={true}
                loading={allPostLoading}
                error={allPostError}
                // count_of_posts={data?.posts_total?.aggregate?.count}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="Published">
              <PostTab
                data={publishedPosts}
                refetch={refetch}
                refetchMain={publishRefetch}
                loading={publishedPostLoading}
                error={publishedPostError}
                // count_of_posts={publishedPosts?.posts_total?.aggregate?.count}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="Drafts">
              <PostTab
                data={draftPosts}
                refetch={refetch}
                refetchMain={draftRefetch}
                loading={draftPostLoading}
                error={draftPostError}
                // count_of_posts={draftPosts?.posts_total?.aggregate?.count}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default PostsMainPage;
